export var MuiTable = {
    root: {},
};
//# sourceMappingURL=MuiTable.js.map